import bus from '@/util/eventbus'
let constants = require('@/util/constants')
let types = require('./mutation-types')
import * as https from '@/apis/http'

/**
 * 
 */
export const getCategoriesSupport = ({ commit, state, dispatch }, payload) => {
    //
    let queryParam = { page: payload.page, size: payload.size }
    https.getCategoriesSupport(queryParam, response => {
        console.log('getCategoriesSupport:', response)
        let categories = response.data
        commit(types.PERSIST_CATEGORIES, { categories })
    }, error => {
        console.log('getCategoriesSupport error:', error)
    })
}

/**
 * 创建类别
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const createCategory = ({ commit, state }, payload) => {
    let parentId = payload.parent_id
    let name = payload.name
    let type = payload.type
    //
    https.createCategory(parentId, name, type, response => {
        console.log('createCategory:', response)
        let category = response.data
        commit(types.ADD_CATEGORY, { category })
    }, error => {
        console.log(error)
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
}

/**
 * 更新类别
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const updateCategory = ({ commit, state }, payload) => {
    let categoryId = payload.category_id
    let name = payload.name
    //
    https.updateCategory(categoryId, name, response => {
        console.log('updateCategory:', response)
        let category = response.data
        commit(types.UPDATE_CATEGORY, { category })
    }, error => {
        console.log(error)
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
}

/**
 * 删除类别
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const deleteCategory = ({ commit, state }, id) => {
    //
    https.deleteCategory(id, response => {
        console.log('deleteCategory:', id, response)
        commit(types.DELETE_CATEGORY, { id })
    }, error => {
        console.log(error)
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
}

/**
 * 获取帮助文档
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const getArticlesSupport = ({ commit, state }, payload) => {
    let queryParam = { categoryId: payload.categoryId, page: payload.page, size: payload.size }
    https.getArticlesSupport(queryParam, response => {
        console.log('getArticlesSupport:', response)
        let articles = response.data
        commit(types.PERSIST_SUPPORT_ARTICLES, { articles })
    }, error => {
        console.log('getArticlesSupport: ', error)
        // bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
}

export const createArticle = ({ commit, state }, payload) => {
    https.createArticle(payload, response => {
        console.log('createArticle:', response)
        //
        if (response.status_code === 200) {
            let article = response.data
            commit(types.ADD_SUPPORT_ARTICLE, { article })
            commit(types.UPDATE_CURRENT_ARTICLE, { article })
        } else {
            //
        }
    }, error => {
        console.log('createArticle error:', error)
    })
}

export const updateArticle = ({ commit, state }, payload) => {
    let article = payload.article
    let successcb = payload.successcb
    let failedcb = payload.failedcb
    https.updateArticle(article, response => {
        // console.log('updateArticle:', response)
        if (response.status_code === 200) {
            let article = response.data
            commit(types.UPDATE_SUPPORT_ARTICLE, { article })
            successcb(article)
        } else {
            failedcb(response)
        }
    }, error => {
        console.log('updateArticle error:', error)
        failedcb(response)
    })
}

export const publishArticle = ({ commit, state }, id) => {
    https.publishArticle(id, response => {
        console.log('publishArticle:', response)
        if (response.status_code === 200) {
            //
        } else {
            //
        }
    }, error => {
        console.log('publishArticle error:', error)
    })
}

export const offlineArticle = ({ commit, state }, id) => {
    https.offlineArticle(id, response => {
        console.log('offlineArticle:', response)
        if (response.status_code === 200) {
            //
        } else {
            //
        }
    }, error => {
        console.log('offlineArticle error:', error)
    })
}

export const deleteArticle = ({ commit, state }, id) => {
    https.deleteArticle(id, response => {
        console.log('deleteArticle:', response)
        if (response.status_code === 200) {
            commit(types.DELETE_SUPPORT_ARTICLE, { id })
        } else {
            //
        }
    }, error => {
        console.log('deleteArticle error:', error)
    })
}

// 搜索
export const filterArticle = ({ commit, state }, payload) => {
    let page = payload.page
    let size = payload.size
    let content = payload.content
    https.filterArticle(page, size, content, response => {
        console.log('filterArticle:', response)
        //
        let articles = response.data
        commit(types.PERSIST_SUPPORT_ARTICLES, { articles })
    }, error => {
        console.log('filterArticle error:', error)
    })
}

// export const newArticle = ({ commit, state }, article) => {
//     commit(types.ADD_SUPPORT_ARTICLE, { article })
//     commit(types.UPDATE_CURRENT_ARTICLE, { article })
// }

export const updateCurrentArticle = ({ commit, state }, article) => {
    commit(types.UPDATE_CURRENT_ARTICLE, { article })
}

export const updateCurrentCategory = ({ commit, state }, category) => {
    commit(types.UPDATE_CURRENT_CATEGORY, { category})
}


/**
 * 
 */
export const queryKnowledgebase = ({ commit, state }) => {
    //
    https.queryKnowledgebase(response => {
        console.log('queryKnowledgebase:', response)
        let knowledgebase = response.data
        commit(types.UPDATE_KNOWLEDGEBASE, { knowledgebase })
    }, error => {
        console.log('queryKnowledgebase error:', error)
    })
}

/**
 * 创建帮助文档
 * @param {*} param0 params
 * @param {*} payload payload
 */
// export const createSupportArticle = ({ commit, state }, payload) => {
//     let title = payload.title
//     let content = payload.content
//     let categories = payload.categories
//     let recommend = payload.recommend
//     let markdown = payload.markdown
//     let accessToken = state.passport.token.access_token
//     https.createSupportArticle(title, content, recommend, markdown, categories, accessToken, response => {
//         // console.log(response)
//         // 通知前端
//         bus.$emit(constants.EVENT_BUS_SUPPORT_NEW_ARTICLE_SUCCESS)
//         //
//         let article = response.data
//         commit(types.ADD_SUPPORT_ARTICLE, { article })
//     }, error => {
//         console.log(error)
//         bus.$emit(constants.EVENT_BUS_SUPPORT_NEW_ARTICLE_ERROR)
//     })
// }

/**
 * 更新帮助文档
 * @param {*} param0 params
 * @param {*} payload payload
 */
// export const updateSupportArticle = ({ commit, state }, payload) => {
//     let articleId = payload.id
//     let title = payload.title
//     let content = payload.content
//     let recommend = payload.recommend
//     let markdown = payload.markdown
//     let categories = payload.categories
//     let accessToken = state.passport.token.access_token
//     https.updateSupportArticle(articleId, title, content, recommend, markdown, categories, accessToken, response => {
//         // console.log(response)
//         //
//         bus.$emit(constants.EVENT_BUS_SUPPORT_UPDATE_ARTICLE_SUCCESS)
//         //
//         let article = response.data
//         commit(types.UPDATE_SUPPORT_ARTICLE, { article })
//     }, error => {
//         console.log(error)
//         bus.$emit(constants.EVENT_BUS_SUPPORT_UPDATE_ARTICLE_ERROR)
//     })
// }

/**
 * 删除帮助文档
 * @param {*} param0 params
 * @param {*} payload payload
 */
// export const deleteSupportArticle = ({ commit, state }, articleId) => {
//     let accessToken = state.passport.token.access_token
//     https.deleteSupportArticle(articleId, accessToken, response => {
//         // console.log(response)
//         //
//         commit(types.DELETE_SUPPORT_ARTICLE, { articleId })
//     }, error => {
//         console.log(error)
//         bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//     })
// }
